import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { Checkbox } from '@change/ds-forms';
import { CheckCircleOutlineIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';
import { useTracking } from '@change-corgi/core/react/tracking';

import { termsAgreementStyles } from './SubmitModalContent.styles';

type SubmitModalContentProps = {
	isTermsAgreed: boolean;
	onTermsChange: (checked: boolean) => void;
};

const Item1: React.FC = () => {
	return (
		<li className="flex items-start gap-2">
			<CheckCircleOutlineIcon className="text-stroke-weak mt-0.5 shrink-0" size="small" aria-hidden />
			<Text variant="body" className="text-typography-strong">
				<Translate value="corgi.petition.starter_dashboard_v2.endorsements.submit_modal.list_item_1" />
			</Text>
		</li>
	);
};

const Item2: React.FC = () => {
	return (
		<li className="flex items-start gap-2">
			<CheckCircleOutlineIcon className="text-stroke-weak mt-0.5 shrink-0" size="small" aria-hidden />
			<Text variant="body" className="text-typography-strong">
				<Translate value="corgi.petition.starter_dashboard_v2.endorsements.submit_modal.list_item_2" />
			</Text>
		</li>
	);
};

const Item3: React.FC = () => {
	return (
		<li className="flex items-start gap-2">
			<CheckCircleOutlineIcon className="text-stroke-weak mt-0.5 shrink-0" size="small" aria-hidden />
			<Text variant="body" className="text-typography-strong">
				<Translate value="corgi.petition.starter_dashboard_v2.endorsements.submit_modal.list_item_3" />
			</Text>
		</li>
	);
};

export const SubmitModalContent: React.FC<SubmitModalContentProps> = ({ isTermsAgreed, onTermsChange }) => {
	const track = useTracking();

	const handleCheckboxChange = (isSelected: boolean) => {
		if (isSelected) {
			void track('petition_manage_confirm_endorsement_modal_checkbox_click');
		}
		onTermsChange(isSelected);
	};
	return (
		<>
			<Text variant="body" className="text-typography-strong mb-4">
				<Translate value="corgi.petition.starter_dashboard_v2.endorsements.submit_modal.description" />
			</Text>
			<ul className="flex list-none flex-col gap-3 pl-0">
				<Item1 />
				<Item2 />
				<Item3 />
			</ul>
			<div className="mt-6 flex flex-col gap-4">
				<hr className="border-stroke-weaker border-t" />
				<div className={termsAgreementStyles().checkboxWrapper()}>
					<Checkbox
						name="terms-agreement"
						isSelected={isTermsAgreed}
						onChange={handleCheckboxChange}
						data-qa="terms-agreement-checkbox"
						data-testid="terms-agreement-checkbox"
					>
						<Text variant="body" className="text-typography-strong text-size-body tracking-0 leading-6 font-normal">
							<Translate value="corgi.petition.starter_dashboard_v2.endorsements.submit_modal.terms_agreement" />
						</Text>
					</Checkbox>
				</div>
				<Text
					variant="body"
					size="small"
					className="text-typography-weak text-size-body-small tracking-0 pl-8 leading-5 font-normal"
				>
					<Translate value="corgi.petition.starter_dashboard_v2.endorsements.submit_modal.review_notice" />
				</Text>
			</div>
		</>
	);
};
